module.exports = __webpack_public_path__ + "img/01-02_Thinking strategically.92403aa4.svg";